import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "map-container",
  class: "map-component"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LayerOptionsComponent = _resolveComponent("LayerOptionsComponent")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LayerOptionsComponent, {
      class: "map-component-btn-layer",
      "onUpdate:style": _ctx.updateStyleMap
    }, null, 8, ["onUpdate:style"]),
    (_ctx.show_save_control)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          class: "map-component-btn-save",
          square: "",
          icon: "save",
          title: "Guardar trazado",
          onClick: _ctx.saveLineString
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}